import { useAppModal } from "@/components"
import type { TSession } from "@/types"
import { dayjs } from "@/utils"
import { ScheduleActivity } from "../ScheduleActivity"

export function useScheduleSession(session: TSession) {
  const tz = session.meta.tz ?? session.tz
  const durationMs = Math.max(session.dtfinish - session.dtstart, 0)
  const startAt = dayjs(session.dtstart).tz(tz)
  const repeatStartAt = dayjs()
    .tz(tz)
    .startOf("day")
    .hour(startAt.hour())
    .minute(startAt.minute())
    .second(0)
    .millisecond(0)
  const repeatFinishAt = repeatStartAt.add(durationMs, "millisecond")

  const modal = useAppModal({
    title: session.title,
    closeOnClickOutside: false,
    children: <ScheduleActivity session={session} activityId={session.activity_id} activityType={session.type} />,
  })

  return {
    ...modal,
    openRepeat: () =>
      modal.open({
        title: session.title,
        children: (
          <ScheduleActivity
            session={{ ...session, id: "", dtstart: repeatStartAt.valueOf(), dtfinish: repeatFinishAt.valueOf() }}
            activityId={session.activity_id}
            activityType={session.type}
          />
        ),
      }),
  }
}
